import { render, staticRenderFns } from "./ExamDataStudent.vue?vue&type=template&id=1c8404dc&scoped=true&"
import script from "./ExamDataStudent.vue?vue&type=script&lang=js&"
export * from "./ExamDataStudent.vue?vue&type=script&lang=js&"
import style0 from "./ExamDataStudent.vue?vue&type=style&index=0&id=1c8404dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8404dc",
  null
  
)

export default component.exports